
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const paymentMadeService = {
    paymentMadeDetails,
  paymentMadeList,
  paymentMadeVendor,
  paymentMadeByDate,
  paymentMadeSearch,
  submitPaymentMade,
  paymentMadeAction

};

//========= PAYMENT MADE SERVICE  =============== 
async function  paymentMadeList() {
    return apiClient.get(`/payment/payment-list`, authHeader());
}

async function  paymentMadeDetails(payRef) {
    return apiClient.get(`/payment/payment-made-details/${payRef}`, authHeader());
}


async function  paymentMadeVendor(vendorId) {
    return apiClient.get(`/payment/payment-made-vendor/${vendorId}`, authHeader());
}




async function  paymentMadeByDate(body) {
    return apiClient.put(`/payment/payment-made-by-date`, body, authHeader());
}


async function  paymentMadeSearch(searchText) {
    return apiClient.get(`/payment/payment-made-search?search=${searchText}`, authHeader());
}



async function  submitPaymentMade(formData) {
    return apiClient.post(`/payment/submit-payment-made`,formData, authHeader());
}


async function  paymentMadeAction(formData) {
    return apiClient.put(`/payment/payment-made-action`,formData, authHeader());
}





// ============= STOCK ADJUSTMENT END============



















